<template>
  <div>
    <!-- Swiper -->
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(items, index) in swiperList"
          :key="index"
        >
          <div class="swiperImgList">
            <img :src="items.thumbnail" alt="" class="park_car_img" />
            <div class="park_car_text">
              <h2>{{ items.parkName }}</h2>
              <p>{{ items.detail }}</p>
            </div>
            <div class="park_car_button flex">
              <button @click="goToDetail(items.uuid)">详情</button>
              <button @click="goToAreaVrDetail(items.uuid)" >园区VR</button>
            </div>
          </div>
        </div>
      </div>

      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
      <!-- <div class="swiper-pagination"></div> -->
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import { mapState } from "vuex";
import { getParkDetail, getParkList } from "../../utils/interface";
export default {
  name: "swiper",
  components: {},
  data() {
    return {
      // 条件
      parkName: "",
      addr: "",
      area: "",
      peoNum: "",
      outPutValue: "",
      capacity: "",
      sorter: "",
      current: 0,
      pageSize: 10,
      effect: "1",
      slides: [
        "Slide 1",
        "Slide 2",
        "Slide 3",
        "Slide 4",
        "Slide 5",
        "Slide 6",
        "Slide 7",
        "Slide 8",
      ],
      swiperList: [],
      setIn: null,
    };
  },
  created() {
    this.setIn = setInterval(() => {
      if (this.isTokenDoor === true) {
        clearInterval(this.setIn);
        this.getParkList();
      }
    }, 500);
  },
  mounted() {},
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  methods: {
    getParkList() {
      let params = {
        parkName: this.parkName,
        addr: this.addr,
        area: this.area,
        peoNum: this.peoNum,
        outPutValue: this.outPutValue,
        capacity: this.capacity,
        sorter: this.sorter,
        current: this.current,
        pageSize: this.pageSize,
      };
      getParkList(params).then((res) => {
        console.log(res);
        if (res.success) {
          this.swiperList = res.data;
          this.$nextTick(() => {
            // 进行初始化 延迟执行，确保数据已经渲染完成
            this.handSwiper();
          });
        }
      });
    },
    handSwiper() {
      let effectIn = this.effect;
      var mySwiper = new Swiper(".swiper-container", {
        // initialSlide: this.swiperList.length,
        initialSlide: 0,
        loop: true,
        loopAdditionalSlides: 3,
        speed: 1000,
        slidesPerView: 5,
        spaceBetween: 30,
        centeredSlides: true,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        on: {
          setTranslate() {
            let slides = this.slides;
            for (var i = 0; i < slides.length; i++) {
              let slide = slides.eq(i);
              let progress = slides[i].progress;
              //slide.html(progress.toFixed(2)); 看清楚progress是怎么变化的
              slide.css({ opacity: "", background: "" });
              slide.transform(""); //清除样式
              if (effectIn == 0) {
                slide.transform("scale(" + (1 - Math.abs(progress) / 8) + ")");
              }
            }
          },
          setTransition(transition) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              slide.transition(transition);
            }
          },
        },

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: {
          delay: 1500,
          stopOnLastSlide: false,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
          autoplayDisableOnInteraction: false,
        },
      });
      //鼠标覆盖停止自动切换
      mySwiper.el.onmouseover = function () {
        mySwiper.autoplay.stop();
      };

      //鼠标离开开始自动切换
      mySwiper.el.onmouseout = function () {
        mySwiper.autoplay.start();
      };
    },
    goToDetail(uuid) {
      //this.$router.push({ name: "allPark", params: { uuid: uuid } });
      let routeData = this.$router.resolve({
        name: "allPark",
        params: { uuid: uuid },
      });
      window.open(routeData.href, "_blank");
    },
    goToAreaVrDetail(uuid) {
      getParkDetail(uuid).then((res) => {
        if(res.vrUrl){
          let routeData = this.$router.resolve({
            name: "VeiwsUrl",
            query: {
              url: res.vrUrl
            }
          });
          window.open(routeData.href, "_blank");
        }else if (res.vrList != null && res.vrList.length > 0) {
          let routeData = this.$router.resolve({
            name: "veiws",
            params: { uuid: uuid },
          });
          window.open(routeData.href, "_blank");
        }else {
          this.$message('该园区未维护园区VR');
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.swiper-container {
  width: 100%;
  height: auto;
  padding: 60px 0;
  margin-left: auto;
  margin-right: auto;
  .swiper-slide {
    // width: 100%;
    // height: 100%;
    text-align: center;
    font-size: 18px;
    background: #fff;
    // height: 200px;

    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    transition-property: all;
  }
}
.park_car_img {
  width: 100%;
  // height: 200px;
  background: #1181ff;
  border-radius: 10px;
}
.park_car_text {
  padding: 20px 15px 10px;
  height: 35%;
  border-bottom: 1px solid #aed4ff;
  h2 {
    margin-bottom: 15px;
    font-size: 20px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  p {
    line-height: 24px;
    font-size: 14px;
    color: #777;
    display: -webkit-box;
    overflow: hidden;
    white-space: normal !important;
    text-overflow: ellipsis;
    word-wrap: break-word;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }
}
.park_car_button {
  button {
    color: #1181ff;
    border: none;
    background: #fff;
    width: 50%;
    padding: 10px 0;
    cursor: pointer;
  }
  button:nth-child(1) {
    border-right: 1px solid #aed4ff;
    border-radius: 0 0 0 10px;
  }
  button:nth-child(2) {
    border-radius: 0 0 10px 0;
  }
}
.swiper-slide {
  height: 100%;
  border-radius: 10px;
}
.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  left: 250px;
  background: #ffffff8a;
  width: 58px;
  height: 58px;
  border-radius: 50%;
  text-align: center;
}
.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  right: 250px;
  background: #ffffff8a;
  width: 58px;
  height: 58px;
  border-radius: 50%;
  text-align: center;
}
.swiperImgList {
  width: 100%;
  // height: 390px;
}
</style>



// WEBPACK FOOTER //
// src/components/parkSwiper/swiper.vue